import Config from '../config';
import {
  handleErrors,
  parseAsJson,
} from '../utils/requestHelpers';
import fetch from '../utils/fetchService';

export const fetchRTPData = async periodName =>
  await fetch(
    Config.endpoints.RETURN_TO_PROVISION
      .replace(/:periodName/, periodName)
  )
    .then(handleErrors({ errorMessage: 'Fetching Return To Provision data failed' }))
    .then(parseAsJson);


export const uploadRTPData = async ( taxYear, rtpDetails ) =>
  await fetch(
    Config.endpoints.UPLOAD_TO_GTW
      .replace(/:taxYear/, taxYear),
    {
      method: 'POST',
      body: JSON.stringify(rtpDetails),
    }
  )
    .then(handleErrors({ errorMessage: 'Upload to Federal failed' }));
